export default "__VITE_ASSET__Bu4$cO3L__"